class OverviewController {
  constructor() {
    'ngInject';
  }
  
  onFetchBetOverview(betoverview, payload) {
    this.betOverviewDetails = betoverview;
    this.payload = payload;
  }
}

export default OverviewController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/betoverview/component/overview/overview.controller.js